import {appendQueryString, getRequest, Response400} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {RegionType} from "../types/RegionType";

/**
 * `YYYY-MM` → average price per m² in PLN. The series holds the last 12 full
 * months (ending on the month before the current one), `null` marks a month
 * without data and an empty object means the region has no BigData coverage.
 * Keys are equal-length, so lexicographic order is chronological.
 */
export type IRegionMonthlyAveragePrices = Record<string, number | null>;

export interface IRegionWithMonthlyAveragePrices {
    id: number;
    name: string;
    full_name_reverted: string;
    type: RegionType;
    stats: {
        average_price_m2_by_month: IRegionMonthlyAveragePrices;
    };
}

interface IRegionsMonthlyAveragePricesResponse {
    results: IRegionWithMonthlyAveragePrices[];
}

/**
 * Batched monthly average prices for regions. The backend assigns
 * prices down the region tree itself (city → district → estate fallback), so
 * callers pass raw region ids. Response order does not follow the parameter
 * order — always match results by `results[].id`.
 *
 * A single unknown region id rejects the whole batch with 400 (ids can go
 * stale — regions get merged or removed while localStorage keeps them), so a
 * failed batch is retried per region and the resolvable part is returned.
 */
export const fetchRegionsMonthlyAveragePrices = async (meta: IRPRequestMeta, regionIds: number[]): Promise<IRegionsMonthlyAveragePricesResponse> => {
    try {
        return await fetchRegionsMonthlyAveragePricesBatch(meta, regionIds);
    } catch (error) {
        if (!(error instanceof Response400) || regionIds.length <= 1) {
            throw error;
        }

        const settledRequests = await Promise.allSettled(regionIds.map((regionId) => fetchRegionsMonthlyAveragePricesBatch(meta, [regionId])));
        // Only stale-id rejections (400) may be dropped; a 5xx/timeout during the
        // retry must still surface as an error instead of a false empty success.
        const hardFailure = settledRequests.find(
            (settledRequest): settledRequest is PromiseRejectedResult => settledRequest.status === "rejected" && !(settledRequest.reason instanceof Response400)
        );

        if (hardFailure) {
            throw hardFailure.reason;
        }

        return {
            results: settledRequests.flatMap((settledRequest) => (settledRequest.status === "fulfilled" ? settledRequest.value.results : []))
        };
    }
};

const fetchRegionsMonthlyAveragePricesBatch = (meta: IRPRequestMeta, regionIds: number[]): Promise<IRegionsMonthlyAveragePricesResponse> => {
    const requestUrl = appendQueryString(apiV2ListLink.region.list(Scenario.REGION_LIST), {
        region: regionIds,
        page_size: regionIds.length
    });

    return getRequest(meta, requestUrl);
};
import {appendQueryString, getRequest, Response400} from "@pg-mono/request";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPRequestMeta} from "../../app/rp_request_meta";
import {RegionType} from "../types/RegionType";

/**
 * `YYYY-MM` → average price per m² in PLN. The series holds the last 12 full
 * months (ending on the month before the current one), `null` marks a month
 * without data and an empty object means the region has no BigData coverage.
 * Keys are equal-length, so lexicographic order is chronological.
 */
export type IRegionMonthlyAveragePrices = Record<string, number | null>;

export interface IRegionWithMonthlyAveragePrices {
    id: number;
    name: string;
    full_name_reverted: string;
    type: RegionType;
    stats: {
        average_price_m2_by_month: IRegionMonthlyAveragePrices;
    };
}

interface IRegionsMonthlyAveragePricesResponse {
    results: IRegionWithMonthlyAveragePrices[];
}

/**
 * Batched monthly average prices for regions. The backend assigns
 * prices down the region tree itself (city → district → estate fallback), so
 * callers pass raw region ids. Response order does not follow the parameter
 * order — always match results by `results[].id`.
 *
 * A single unknown region id rejects the whole batch with 400 (ids can go
 * stale — regions get merged or removed while localStorage keeps them), so a
 * failed batch is retried per region and the resolvable part is returned.
 */
export const fetchRegionsMonthlyAveragePrices = async (meta: IRPRequestMeta, regionIds: number[]): Promise<IRegionsMonthlyAveragePricesResponse> => {
    try {
        return await fetchRegionsMonthlyAveragePricesBatch(meta, regionIds);
    } catch (error) {
        if (!(error instanceof Response400) || regionIds.length <= 1) {
            throw error;
        }

        const settledRequests = await Promise.allSettled(regionIds.map((regionId) => fetchRegionsMonthlyAveragePricesBatch(meta, [regionId])));
        // Only stale-id rejections (400) may be dropped; a 5xx/timeout during the
        // retry must still surface as an error instead of a false empty success.
        const hardFailure = settledRequests.find(
            (settledRequest): settledRequest is PromiseRejectedResult => settledRequest.status === "rejected" && !(settledRequest.reason instanceof Response400)
        );

        if (hardFailure) {
            throw hardFailure.reason;
        }

        return {
            results: settledRequests.flatMap((settledRequest) => (settledRequest.status === "fulfilled" ? settledRequest.value.results : []))
        };
    }
};

const fetchRegionsMonthlyAveragePricesBatch = (meta: IRPRequestMeta, regionIds: number[]): Promise<IRegionsMonthlyAveragePricesResponse> => {
    const requestUrl = appendQueryString(apiV2ListLink.region.list(Scenario.REGION_LIST), {
        region: regionIds,
        page_size: regionIds.length
    });

    return getRequest(meta, requestUrl);
};
